var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6513 1.5777L18.0397 5.59321L13.9822 6.98452M7.27471 22.4375L5.88633 18.4219L9.94378 17.0306M3.35254 14.5C2.47496 11.4542 3.23615 8.03601 5.63611 5.63605C8.95983 2.31234 14.2364 2.13171 17.7724 5.09418M20.6476 9.50001C21.5252 12.5459 20.764 15.964 18.364 18.364C15.0091 21.7189 9.66456 21.8714 6.12871 18.8216",
    stroke: "currentColor",
    strokeWidth: 1.4132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.1f62e1756d7b119de9b81421b3962c2d.svg";
export { ForwardRef as ReactComponent };